import { Spinner, SpinnerSizes } from '@inno-ui/spinner'
import { Trans } from 'react-i18next'

import styles from './AppLoader.module.scss'

export const AppLoader = () => {
  return (
    <div className={styles.loading}>
      <div className={styles.spinner}>
        <Spinner size={SpinnerSizes.XL} />
      </div>
      <Trans i18nKey='common.loading' components={{ b: <b /> }} />
    </div>
  )
}
